<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    <div class="well-title">
        @if (!loading && isEditMode) {
            <div class="col-md-12">
                <span class="customernumber" [nz-tooltip]="customer.CustomerNumber">
                    Edit Customer {{ customer.CustomerNumber }}
                </span>
            </div>
        }
        @if (!loading && !isEditMode) {
            <div class="col-md-12">Create Customer</div>
        }
    </div>
    <div>&nbsp;</div>
    <div class="col-md-12">
        <a class="back-link" routerLink="/report/arreport/customers">Back to Customers</a>
    </div>
    <div class="col-md-12 well-content">
        @if (successMsg) {
            <div class="alert alert-success">{{ successMsg }}</div>
        }
        @if (errorMsg) {
            <div class="alert alert-danger">{{ errorMsg }}</div>
        }
        <div class="panel panel-default">
            <div class="panel-heading">General</div>
            <div class="panel-body">
                <form #frm="ngForm" class="form-horizontal">
                    <div class="form-group">
                        <label for="custName" class="col-md-2 control-label">
                            Customer Name <span style="color: red">*</span>
                        </label>
                        <div class="col-md-6">
                            <input
                                name="custName"
                                type="text"
                                required
                                maxlength="255"
                                #custNameMdl="ngModel"
                                class="form-control"
                                [(ngModel)]="customer.CustomerName" />
                            @if (custNameMdl.touched && custNameMdl.invalid) {
                                <span class="text-danger"> Customer Name is required </span>
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="custNum" class="col-md-2 control-label">
                            Customer Number <span style="color: red">*</span>
                        </label>
                        <div class="col-md-6">
                            <input
                                name="custNum"
                                type="text"
                                required
                                maxlength="255"
                                #custNumMdl="ngModel"
                                class="form-control"
                                [(ngModel)]="customer.CustomerNumber" />
                            @if (custNumMdl.touched && custNumMdl.invalid) {
                                <span class="text-danger"> Customer Number is required </span>
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="custEmail" class="col-md-2 control-label">
                            Customer Email <span style="color: red">*</span>
                        </label>
                        <div class="col-md-6">
                            <input
                                name="custEmail"
                                type="text"
                                required
                                maxlength="255"
                                #custEmailMdl="ngModel"
                                class="form-control"
                                [(ngModel)]="customer.EmailAddress" />
                            @if (custEmailMdl.touched && custEmailMdl.invalid) {
                                <span class="text-danger"> Customer Email is required </span>
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label">Options</div>
                        <div class="col-md-6 options-div">
                            <div>
                                <nz-switch
                                    name="shouldPrint"
                                    id="shouldPrint"
                                    nzSize="small"
                                    [(ngModel)]="customer.ShouldPrint"
                                    [nzCheckedChildren]="checkedTmpl"
                                    [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                Print?
                            </div>
                            <div>
                                <nz-switch
                                    name="shouldEmail"
                                    id="shouldEmail"
                                    nzSize="small"
                                    [(ngModel)]="customer.ShouldEmail"
                                    [nzCheckedChildren]="checkedTmpl"
                                    [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>

                                Email?
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <button class="btn btn-default" (click)="save(frm)">Save Changes</button>
        @if (customer.CustomerID) {
            <button class="btn btn-danger pull-right" (click)="remove()">Delete Customer</button>
        }
    </div>
</div>
<ng-template #checkedTmpl><nz-icon nzType="check" /></ng-template>
<ng-template #uncheckedTmpl><nz-icon nzType="close" /></ng-template>
